import { apiV2Client } from '@/services/client/ApiClient.js';
import { handleError } from '@/services/ErrorHandler.js';

export default {
  getComments(layerId) {
    return apiV2Client.get(`/drawings/${layerId}/comments`).then((response) => {
      return response.data;
    });
  },
  getCommentsByIds(layerIds) {
    return apiV2Client
      .get(`/drawings/by-ids/${layerIds}/comments`)
      .then((response) => {
        return response.data;
      });
  },
  addComment(layerId, data) {
    return apiV2Client
      .post(`/drawings/${layerId}/comments`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  editComment(commentId, layerId, data) {
    return apiV2Client
      .put(`/drawings/${layerId}/comments/${commentId}`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  deleteComment(commentId, layerId) {
    return apiV2Client
      .delete(`/drawings/${layerId}/comments/${commentId}/delete`)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  }
};
